export default __webpack_public_path__ + "static/media/calStateTruck.1b76f65b.jpeg";